import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tx-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() confirmButtonText: string = '';
  @Input() rejectButtonText: string = '';
  @Input() showHeaderCloseButton: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}

  //ensure propagation doesnt work its way up
  //window takes priority - ensure stack is applying binding to the correct modal

  ngOnInit() {
    //bind keyup to window dom
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  ngOnDestroy() {
    //ensure removal
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.confirm();
    }
  }

  confirm(): void {
    this.activeModal.close();
  }

  reject(): void {
    this.activeModal.dismiss();
  }
}
